// src/hooks/usePerfil.js
import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export function usePerfil() {
    const { user, reloadUser } = useAuth(); // Sincroniza el estado global de sesión
    const { showToast } = useToast();

    const [formDatos, setFormDatos] = useState({ nombre: '', apellidos: '', numeroColegiado: '', especialidad: '' });
    const [editando, setEditando] = useState(false);
    const [guardando, setGuardando] = useState(false);

    // Hidratamos el formulario local cuando el usuario global cambie
    useEffect(() => {
        if (user) {
            setFormDatos({
                nombre: user.nombre || '',
                apellidos: user.apellidos || '',
                numeroColegiado: user.numeroColegiado || '',
                especialidad: user.especialidad || 'Medicina General'
            });
        }
    }, [user]);

    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormDatos(prev => ({ ...prev, [name]: value }));
    }, []);

    const guardarCambiosPerfil = useCallback(async () => {
        setGuardando(true);
        try {
            // FIX: '/usuarios/perfil' no existía en el backend — el perfil nunca se guardaba.
            // El endpoint real es PUT /api/auth/perfil (self-service, validado con Zod).
            await api.put('/auth/perfil', formDatos);
            await reloadUser(); // Forzamos al AuthContext a refrescar el token/datos
            showToast('Perfil clínico actualizado con éxito', 'success');
            setEditando(false);
        } catch (error) {
            showToast('Error al actualizar las credenciales de identidad', 'error');
        } finally {
            setGuardando(false);
        }
    }, [formDatos, reloadUser, showToast]);

    return {
        user,
        formDatos,
        editando,
        setEditando,
        guardando,
        handleInputChange,
        guardarCambiosPerfil,
        reloadUser
    };
}